import { useInfiniteEntityGroups } from '@/models/entityGroup';
import useDebouncedState from '@/utils/useDebouncedState';

const GROUPS_PER_PAGE = 20;

export const useGroupFilterState = () => {
  const [search, debouncedSearch, setSearch] = useDebouncedState<string>('', 300);

  // The first hook is to get the total count of options without search filter
  // React-query will only fetch once, even with two hooks (as long as the params are the same)
  const { data: initialData } = useInfiniteEntityGroups({
    limit: GROUPS_PER_PAGE,
  });
  const { data, fetchNextPage, isLoading } = useInfiniteEntityGroups({
    limit: GROUPS_PER_PAGE,
    search: debouncedSearch || undefined,
  });

  const entityGroups = data?.pages.flatMap((page) => page.entityGroups) ?? [];
  const count = initialData?.pages[0]?.meta.count || 0;

  return {
    search,
    setSearch,
    fetchNextPage,
    isLoading,
    entityGroups,
    count,
  };
};
